import React, { useState, useEffect } from "react"
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import apiRequest from '../hooks/ApiRequest'
import HomeLayout from "../components/Layouts"
import { toast } from "react-toastify"
import CommonSearch from "../hooks/Search"

const ManageDocuments = () => {
  const [searchTerm, setSearchTerm] = useState("")
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [formData, setFormData] = useState({ name: "", active: true })

  useEffect(() => {
    fetchDocuments()
  }, [])
  const fetchDocuments = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_DOCUMENT}/DocumentMaster`,
        "GET"
      )

      console.log("API Response:", response)

     
      const actualData = response.data?.data || response.data

      if (response.success || response.data?.success) {
        setDocuments(Array.isArray(actualData) ? actualData : [])
      } else {
        toast.error(response.message || "Failed to fetch documents")
      }
    } catch (error) {
      console.error(error)
      toast.error("Error fetching documents")
    } finally {
      setLoading(false)
    }
  }




  const handleSearch = (value) => {
    const filterTable = documents.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    )
    setDocuments(filterTable)
  }

  const clearSearch = () => {
    setSearchTerm("")
    fetchDocuments()
  }

  const handleCreate = () => {
    setSelectedDocument(null)
    setFormData({ name: "", active: true })
    setModalVisible(true)
  }

  const handleEdit = (record) => {
    setSelectedDocument(record)
    setFormData({ name: record.name, active: record.active })
    setModalVisible(true)
  }

  const handleDelete = async (id) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_DOCUMENT}/DocumentMaster/delete/${id}`,
        "POST"
      )
      if (response.success) {
        toast.success("Document deleted")
        fetchDocuments()
      } else {
        toast.error(response.message || "Delete failed")
      }
    } catch (error) {
      toast.error("Error deleting document")
    }
  }

  const handleSave = async () => {
    try {
      const loggedInUserID = localStorage.getItem("loggedInUserID");
      const role = localStorage.getItem("roles");
      const payload = {
        id: selectedDocument ? selectedDocument.id : 0,
        name: formData.name,
        active: formData.active,
        createdBy: selectedDocument ? selectedDocument.createdBy : role,
        createdAt: selectedDocument ? selectedDocument.createdAt : new Date().toISOString(),
        modifiedBy: role,
        modifiedAt: new Date().toISOString(),
      };

      let url = `${process.env.REACT_APP_BASE_URL_DOCUMENT}/DocumentMaster`;
      if (selectedDocument) {
        url = `${process.env.REACT_APP_BASE_URL_DOCUMENT}/DocumentMaster/update/${selectedDocument.id}`;
      }

      const response = await apiRequest(url, "POST", payload);

      if (response.success) {
        toast.success(
          selectedDocument
            ? "Document updated successfully"
            : "Document created successfully"
        );
        fetchDocuments();
        setModalVisible(false);
      } else {
        toast.error(response.message || "Save failed");
      }
    } catch (error) {
      toast.error("Error saving document");
    }
  };


  const columns = [
    {
      title: "Document Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (active) => (active ? "Yes" : "No"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => handleEdit(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this Document?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    // <HomeLayout>
    <div title="Manage Documents" >
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: "#0C1362",
                  fontWeight: "600",
                  fontSize: "20px",
                }}
              >
                Manage Documents
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
              onClear={clearSearch}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <Button type="primary" onClick={() => handleSearch(searchTerm)}>
              Search
            </Button>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <Button type="primary" onClick={handleCreate}>
              Add Document
            </Button>
          </Col>
        </Row>
      </div>
      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ marginTop: 20 }}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={documents}
          rowKey="id"
        />

      )}
      <Modal
        title={selectedDocument ? "Edit Document" : "Add Document"}
        centered
        visible={modalVisible}   
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={600}
      >

        <div>
          <label style={{ fontWeight: "bold" }}>Name:</label>
          <Input
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
            placeholder="Enter document name"
            style={{ marginBottom: "15px" }}
          />
          <Button type="primary" onClick={handleSave}>
            {selectedDocument ? "Update" : "Create"}
          </Button>
        </div>
      </Modal>
    </div>
    // </HomeLayout>
  )
}

export default ManageDocuments
